import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfirmConvertToInvoiceModal = ({
  isOpen,
  onConfirm,
  onReject
}) => {
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    "data-test-id": "confirm-convert-to-invoice-modal",
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.convertToInvoiceButton.modal.confirm.message"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.convertToInvoiceButton.modal.confirm.description"
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.convertToInvoiceButton.modal.confirm.confirmLabel"
    }),
    onConfirm: onConfirm,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.convertToInvoiceButton.modal.confirm.rejectLabel"
    }),
    onReject: onReject,
    size: "auto"
  });
};
export default ConfirmConvertToInvoiceModal;